(function () {
  'use strict';

  angular
    .module('materialAdmin')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('materialAdmin', {
        url: '/material-admin',
        templateUrl: 'material-admin/material-admin.tpl.html',
        controller: 'MaterialAdminCtrl',
        controllerAs: 'mactrl'
      });
  }
}());
